export const removeLeadingSlash = (value: string) => value.replace(/^\/+/g, "");
